import React from 'react';
import './bigtext.css';

function BigText({ type = 3, children }) {
  const renderHeader = () => {
    switch (type) {
      case 1:
        return <h1 className='big-text'>{children}</h1>;
      case 2:
        return <h3 className='big-text-2'>{children}</h3>;
      case 4:
        return <h1 className='big-text-2'>{children}</h1>;
      default:
        // Caso type não seja 1 nem 2, retorna o padrão h1
        return <h1 className='big-text'>{children}</h1>;
    }
  };

  return renderHeader();
}

export default BigText;
